import type { FC } from 'react'
import { Divider } from 'antd'
import classNames from 'classnames'

import { UtilService } from 'common/services/utilService'
import { ALT_CONSTANTS } from 'common/constants/altConstants'

import { CartCollapse } from 'features/Cart/components/CartCollapse/CartCollapse'
import { CartError } from 'features/Cart/components/CartError/CartError'
import type { IOptionShopCartDay } from 'features/Option'
import trashIcon from 'features/Cart/assets/trash.svg'

import styles from './cartShopItem.module.scss'
import collapseStyles from 'features/Cart/components/CartCollapse/cartCollapse.module.scss'

interface IProps {
  days: IOptionShopCartDay[]
  handleRemoveEntireOption: () => void
  handleRemoveDay: (date: string) => void
}

export const CartShopDays: FC<IProps> = ({ days, handleRemoveEntireOption, handleRemoveDay }) => {
  return (
    <CartCollapse
      title={`${days.length} Days Selected`}
      handleRemoveSlot={() => {
        handleRemoveEntireOption?.()
      }}
      additionalActiveTitle={`${days.length} days`}>
      <div>
        {days.map((day) => (
          <div key={day.date} className={styles.dateSection}>
            <div className={styles.dateHeader}>
              <span>{day.title}</span>

              <button
                className={classNames(collapseStyles.parentRemoveButton, 'p-0')}
                onClick={() => {
                  handleRemoveDay?.(day.date)
                }}
                title='Remove this day'
                data-cy={`delete-day-${day.date}`}>
                <img
                  src={trashIcon}
                  alt={ALT_CONSTANTS.ACTION_ICON}
                  className={collapseStyles.parentRoomRemoveIcon}
                />
              </button>
            </div>

            <div className={classNames(styles.parent, styles.slotItem)}>
              <div>{day.title}</div>
              <span>{UtilService.numberToDollar(day.price)}</span>
            </div>
            <CartError error={day?.error_message} className={styles.slotItem} />
          </div>
        ))}
        <Divider className={styles.divider} />
        <div className={classNames(styles.parent, styles.grandTotal)}>
          <span>Grand Total</span>
          <span>{UtilService.numberToDollar(days.reduce((sum, d) => sum + d.price, 0))}</span>
        </div>
      </div>
    </CartCollapse>
  )
}
